import React from 'react'
import img from "../images/sub-img.png"
import "./Subcontainer.css"
const subheader = () => {
  return (
    <div className='sub-container'>
        <img src={img} alt="" />
    </div>
  )
}

export default subheader